/**
 * Every route this feature owns or is entered from, each with one job — the two
 * wizard/dashboard routes plus the Integrations entry points the card and the
 * "Manage GSC domains" page navigate between. Kept as constants because the code
 * that navigates between them is scattered — the Integrations card's CTAs
 * (`features/Integrations/SearchPerformanceCard.tsx`), the OAuth callback's
 * same-tab fallback (`pages/GscOAuthCallbackPage.tsx`), the dashboard's
 * redirect into the wizard, and the "Manage GSC domains" page's Back and Reconnect
 * — and a drifting literal breaks a redirect silently. The route table
 * (`Routes.jsx`) and the sidebar (`layout/SideBar/menuItems.tsx`) still declare
 * these paths as their own literals; they register routes rather than navigate,
 * and do not read this file.
 */
export const SEARCH_PERFORMANCE_ROUTE = '/search-performance';
export const SEARCH_PERFORMANCE_CONNECT_ROUTE = '/search-performance/connect';
export const INTEGRATIONS_ROUTE = '/integrations';
export const GSC_SETTINGS_ROUTE = '/integrations/settings';

/**
 * Asks the connect route to start at the auth step even though a live
 * connection exists. Presence is the signal; the value is ignored.
 *
 * Needed because the two reasons to arrive with an ACTIVE source are
 * indistinguishable from state: a customer redirected off the dashboard mid-first
 * sync wants the sync step, and a customer who clicked "Reconnect" wants to
 * re-authenticate. That is intent, not data — so it travels in the URL. Read in
 * `gsc-connection/useGscConnectionFlow.ts`.
 */
export const GSC_RECONNECT_PARAM = 'reconnect';

/** Where any "Reconnect" CTA points. */
export const SEARCH_PERFORMANCE_RECONNECT_ROUTE = `${SEARCH_PERFORMANCE_CONNECT_ROUTE}?${GSC_RECONNECT_PARAM}=1`;
